import { useFormikContext } from "formik"
import { Actions, type ActionsProps } from "../Actions"
import { FormActionsAccept } from "./components/atoms/FormActionsAccept"

type Props = Omit<ActionsProps, "loading">

function FormActionsWrapper(props: Props) {
    const { isSubmitting } = useFormikContext()

    return (
        <Actions
            loading={isSubmitting}
            {...props}
        />
    )
}

export const FormActions = Object.assign(FormActionsWrapper, Actions)
FormActions.Accept = FormActionsAccept
